import { render, staticRenderFns } from "./foodItem.vue?vue&type=template&id=95741332&"
import script from "./foodItem.vue?vue&type=script&lang=js&"
export * from "./foodItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports